<template>

    <div class="fan-control">
    <div class="status">
      <div class="status-item">
        <el-button plain type="primary" @click="connectDevice" v-if="!connected" size="small">连接设备</el-button>
        <el-button plain type="danger" @click="disconnectDevice" v-if="connected" size="small">断开连接</el-button>
        
      </div>
    </div>
    <el-row :gutter="24">
       <el-col :span="24">
        <div class="status-item">
              <label>转速1：</label>
              <span>{{ fanSpeed0 }}</span>
               <label>转速2：</label>
              <span>{{ fanSpeed1 }}</span>
            </div>
           
            <div class="status-item">
              <label>探头温度：</label>
              <span :style="{ color: tempColor0 }">{{ temperature0 }}°C</span>
              <label>模块温度：</label>
              <span :style="{ color: tempColor1 }">{{ temperature1 }}°C</span>
           
            </div>  
             <div class="status-item">             
              <label>风扇电流：</label>
              <span>{{ (current/1000*2).toFixed(2) }} A</span>
            </div>             
       </el-col>
    </el-row>
    <el-row :gutter="24">
            <el-col :span="24">
                <el-radio-group v-model="smartMode0" size="large">
                <el-radio-button label="手动" value="1" />
                <el-radio-button label="温控" value="2" />
                <el-radio-button label="油门" value="3" />
            </el-radio-group>
             <el-slider v-model="duty0" :step="10" show-stops :disabled="smartMode0!='1'"/>  
       </el-col>
      </el-row>
      <br/>
    <el-row :gutter="24">
       <el-col :span="24">
            <el-input-number style="width: 200px;" v-model="offTemp" :min="0" :max="100" >
              <template #prefix>
              <span>停止温度</span>
              </template>
                    <template #suffix>
                        <span>℃</span>
                    </template>
            </el-input-number>    <br/> 
            <el-input-number style="width: 200px;" v-model="startTemp" :min="0" :max="100" >
              <template #prefix>
              <span>启动温度</span>
              </template>
                    <template #suffix>
                        <span>℃</span>
                    </template>
            </el-input-number> <br/>     
             <el-input-number style="width: 200px;" v-model="fullTemp" :min="0" :max="100" >
              <template #prefix>
              <span>全速温度</span>
              </template>
                    <template #suffix>
                        <span>℃</span>
                    </template>
            </el-input-number>  <br/> 
             <el-input-number style="width: 200px;" v-model="alarmTemp" :min="0" :max="100" >
              <template #prefix>
              <span>报警温度</span>
              </template>
                    <template #suffix>
                        <span>℃</span>
                    </template>
            </el-input-number> 
       </el-col>
      </el-row>
      <br/>
        <div>
          <el-button  @click="loadCfg" :disabled="!connected">取消</el-button>
          <el-button type="success" @click="saveCfg" >保存</el-button>
        </div>
    
  </div>

    
    <div class="service-control" v-if="connected && false">
      <div class="input-group">
        <label>服务UUID:</label>
        <input type="text" v-model="serviceUUID" placeholder="输入服务UUID">
      </div>
      
      <div class="input-group">
        <label>特征UUID:</label>
        <input type="text" v-model="characteristicUUID" placeholder="输入特征UUID">
      </div>

      <div class="command-section">
        <input type="text" v-model="command" placeholder="输入命令（十六进制）">
        <button @click="sendCommand" :disabled="!canSend">发送命令</button>
      </div>
    </div>

    <!-- <div class="logs">
      <h3>日志</h3>
      <div v-for="(log, index) in logs" :key="index" class="log-item">
        [{{ log.timestamp }}] {{ log.message }}
      </div>
    </div> -->
</template>
<script setup>
  import { ref, reactive, computed, onMounted } from 'vue'
  import { ElMessage } from 'element-plus'

  
const fanSpeed0 = ref(0)
const temperature0 = ref(25)
const fanSpeed1 = ref(0)
const temperature1 = ref(25)
  
const connected = ref(false)
const device = ref(null)

let pwmChanged = false
const serviceUUID = ref('0000ffe0-0000-1000-8000-00805f9b34fb') // 默认心率服务
const characteristicUUID = ref('0000ffe1-0000-1000-8000-00805f9b34fb') // 默认心率测量特征
// 新增状态变量
const notificationUUID = ref('0000ffe4-0000-1000-8000-00805f9b34fb') // 示例UUID
const isSubscribing = ref(false)
const notificationCharacteristic = ref(null)




const duty0 = ref(0)
const smartMode0 = ref('1')

const offTemp = ref(0)
const startTemp = ref(0)
const fullTemp = ref(0)
const alarmTemp = ref(0)
const current = ref(0)


let   dutyChar = null

let server = null
let service = null 
let characteristic = null

const command = ref('')
// const logs = reactive([])

const deviceInfo = reactive({
  name: '',
  id: ''
})



// 温度颜色计算
const tempColor0 = computed(() => {
  if (temperature0.value < 40) return '#4CAF50'
  if (temperature0.value < 50) return '#FFC107'
  return '#F44336'
})

// 温度颜色计算
const tempColor1 = computed(() => {
  if (temperature1.value < 40) return '#4CAF50'
  if (temperature1.value < 50) return '#FFC107'
  return '#F44336'
})

// 计算属性
//const connectionStatus = computed(() => connected.value ? '已连接' : '未连接')
const canSend = computed(() => command.value.trim() !== '')


// 日志记录
const addLog = (message) => {
    console.log(message)
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: true,    
      optionalServices: [serviceUUID.value],
      // filters: [ 
      //   { namePrefix: 'BLE' } 
      // ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    addLog(`已连接至设备: ${device.value.name}`)

    service = await server.getPrimaryService(serviceUUID.value)
    dutyChar = await service.getCharacteristic(characteristicUUID.value)

    await loadCfg()


    startNotifications()
  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  fanSpeed0.value = 0
  fanSpeed1.value = 0
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}

// 发送命令
const sendCommand = async () => {
  try {
    //const server = await device.value.gatt.connect()
    //const service = await server.getPrimaryService(serviceUUID.value)
    //const characteristic = await service.getCharacteristic(characteristicUUID.value)
    
    // 将命令转换为ArrayBuffer
    const data = hexStringToArrayBuffer(command.value.trim())
    
    await dutyChar.writeValue(data)
    addLog(`命令已发送: ${command.value}`)
    command.value = ''
  } catch (error) {
    addLog(`发送失败: ${error}`)
  }
}

// 十六进制字符串转ArrayBuffer
const hexStringToArrayBuffer = (hex) => {
  hex = hex.replace(/\s/g, '')
  if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
  
  const buffer = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    buffer[i/2] = parseInt(hex.substr(i, 2), 16)
  }
  return buffer
}



// 新增文本解析方法
// const arrayBufferToString = (buffer) => {
//   return new TextDecoder().decode(buffer)
// }

// 在handleNotifications中添加格式选择
const handleNotifications = (event) => {
  if( pwmChanged ){
    pwmChanged = false
    return
  }
  const value = event.target.value
  console.log(value)
  let mode0 = value.getUint8(0,true);
  let tmpBoard = value.getInt16(1,true);
  let tmpChip = value.getInt16(1+2,true);
  let duty = value.getUint8(1+2+2,true);
  let accMV = value.getUint16(1+2+2+1,true);
  let rpm0 = value.getUint16(1+2+2+1+2,true);
  let rpm1 = value.getUint16(1+2+2+1+2+2,true);
  let cu = value.getUint16(12,true)
  current.value = cu
  fanSpeed0.value = rpm0
  temperature0.value = tmpBoard
  fanSpeed1.value = rpm1
  temperature1.value = tmpChip
  if(smartMode0.value!='1'){
    duty0.value = duty
  }
  // fanSpeed.value = value.getUint16(5,true);
  // if(pwm.value!= duty){
  //   pwm.value = duty
  // }
  //temperature.value = tmp


  console.log('data0',mode0,accMV,duty,cu)

  //let data = arrayBufferToString(value.buffer)
  //let json = JSON.parse(data)  
  //console.log('json',data)
 // addLog(`收到数据: ${data}`)
}

// 新增启用通知方法
const startNotifications = async () => {
  try {
  
    characteristic = await service.getCharacteristic(notificationUUID.value)

    if (!characteristic.properties.notify) {
      throw new Error('该特征不支持通知功能')
    }

    await characteristic.startNotifications()
    characteristic.addEventListener('characteristicvaluechanged', handleNotifications)
    notificationCharacteristic.value = characteristic
    isSubscribing.value = true
    addLog('通知功能已启用')
  } catch (error) {
    addLog(`启用通知失败: ${error}`)
  }
}


const loadCfg = async ()=>{
  const chval = await dutyChar.readValue()
  let cfg = new Uint8Array(chval.buffer);
  smartMode0.value = cfg[2]+'';
  offTemp.value = cfg[3]
  startTemp.value = cfg[4]
  fullTemp.value = cfg[5]
  alarmTemp.value = cfg[6]


  console.log('loadcfg',cfg)

    // smartMode.value = (cfg[2]===2)
    // for(let i=0;i<4;i++){
    //   tempArray.value[i] = cfg[4+i]
    //   pwmArray.value[i] = cfg[8+i]
    // }
}
const saveCfg = async ()=>{
  //let mode = parseInt(smartMode0);
  await dutyChar.writeValue(hexStringToArrayBuffer("1000"))
  const chval = await dutyChar.readValue()
  console.log("saveCfg",chval)
  let cfg = new Uint8Array(chval.buffer);
  cfg[0] = 0x11
  cfg[1] = 0x08
  cfg[2] = parseInt( smartMode0.value);
  cfg[3] = offTemp.value 
  cfg[4] = startTemp.value 
  cfg[5] = fullTemp.value 
  cfg[6] = alarmTemp.value 
  cfg[7] = duty0.value
  console.log("saveCfg",cfg)

  await dutyChar.writeValue(chval)
  ElMessage.success('保存成功')
}
onMounted(()=>{
    
})
</script>
<style scoped>
.device-info{
    width: 90%;
}

.fan-control {
  max-width: 1000px;
  margin: 2rem auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.status {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.status-item {
  font-size: 1.2em;
}

.fan-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 10px auto;
}

.fan {
  width: 100%;
  height: 100%;
  position: relative;
  transition: filter 0.3s;
}

.blade {
  position: absolute;
  width: 20px;
  height: 50px;
  background: #607D8B;
  left: 50%;
  transform-origin: bottom;
  border-radius: 10px;
}

.blade:nth-child(1) { transform: translateX(-50%) rotate(0deg); }
.blade:nth-child(2) { transform: translateX(-50%) rotate(120deg); }
.blade:nth-child(3) { transform: translateX(-50%) rotate(240deg); }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.controls {
  margin-top: 20px;
}

input[type="range"] {
  width: 80%;
  height: 10px;
  background: #ddd;
  border-radius: 5px;
}

.speed-percent {
  font-size: 1.5em;
  margin-top: 10px;
  color: #2196F3;
}


</style>